import { Paper, Typography } from "@mui/material";
import styles from "./Events.module.css";
import eventsImage from "../../assets/fallback/image7.jpg";

const Events = () => {
  return (
    <div className={styles.mainWrapper}>
      <div className="background">
        <img
          src={eventsImage}
          alt="Footbal"
          loading="lazy"
          decoding="async"
          style={{ width: "100%" }}
          className="background-image-desktop"
        />
      </div>

      <div className="white-paper">
        <Paper
          style={{
            width: "88%",
            position: "relative",
            top: "-15px",
            height: "calc(100% + 15px)",
            padding: "20px 32px 20px 32px",
            boxShadow: "0 0 6px 0 rgba(0, 0, 0, 0.09)",
          }}
        >
          <Typography
            variant="h5"
            component="h2"
            style={{ color: "#01245a", marginBottom: "20px" }}
          >
            <strong>Events</strong>
          </Typography>
          <Typography
            variant="body2"
            style={{
              color: "#797979",
              fontSize: "14px",
              textAlign: "justify",
              textAlignLast: "left",
              wordSpacing: "0px",
              letterSpacing: "0.2px",
              lineHeight: "1.6",
              hyphens: "auto",
            }}
          >
            WHS Sports Hub hosts premier sporting and lifestyle events across
            India. From grassroots tournaments to national-level showcases, our
            events are professionally managed, fully staffed, and held at
            top-tier venues built for excellence.
            <br />
            <br />
            We are proud to host the WHS Sports Hub Golf Cup, one of India’s
            most anticipated amateur golf tournaments, along with a dynamic
            calendar of championships, youth leagues, fitness challenges, and
            community sports festivals across multiple sports—including cricket,
            football, pickleball, and more.
            <br />
            <br />
            Check out our upcoming events and be a part of the action—wherever
            you are.
          </Typography>
        </Paper>
      </div>
      <div className="footer"></div>
    </div>
  );
};

export default Events;
